<template>
    <div>
        <div id="scene" >
            <div  class="banner absolute-center" v-if="this.dataLoaded">
                <div class="bg-image-container" >
                    <div class="bg-image"
                    data-aos="animation-background-picture"
                    data-aos-duration="3000"
                    ></div>
                </div>
                <div class="container">
                    <div> 
                        <!-- <h1 v-html="this.page.attributes.field_description.processed"></h1> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'section-lo-studio-legale',
    data:()=>{
        return {
            idIntroPage:"79901d9f-2b64-4047-976b-04e04f27094f",
            page:[],
            dataLoaded:true,
            customClass:false,
            scrollIns: null
        }
    },
    methods:{
        findObjectbyKey:(array, key, value)=>{
            for (var i = 0; i < array.length; i++) {
                if (array[i][key] === value) {
                    return array[i];
                }
            }
            return null;
        },
    },
    mounted(){
        // fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {method: "GET", mode: 'cors'})
        // .then(response=>{
        //     return response.json()
        // })
        // .then(json=>{
        //     this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
        //     this.dataLoaded = true;
        // })
        // .catch(function(error) {  
        //     console.log('Request failed', error)  
        // });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.banner {
    width: 100%;
    height: 65vh;
    position: relative;
    .container {
        padding: 0px 10rem;
    }
    h1, h1 p{
        font-family: "Playfair Display";
        text-align: center;
        color: #fff;
        font-size: 2.5rem;
        line-height: 1.3em;
    }
}
.banner{
    overflow: hidden; 
    .bg-image {
    background: url("../assets/sez-bg2.png") center no-repeat;
    background-size:cover;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: -1;
}}


@media (max-width:992px){
.banner h1, .banner h1 p {
    font-size: 2rem;
    
}
.banner .container {
    padding: 0px 0rem;
}
}
@media (max-width:768px){
    .banner .container {
        padding: 0px 1rem;
        h1, h1 p{
            font-size: 1.4rem;
        }
    }
}
</style>
